module.exports = "/images/vendor/flag-icon-css/flags/4x3/am.svg?06509258e6113e2e0e54592337ac8171";